import { c as _c } from "react/compiler-runtime";
import type { ApiNode, ApiNodeData, ApiNodeDataRules, NodeExecutionDetailRules } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import RuleTraceRow from '../rule-trace-row';
type RulesNodeGroupProps = {
  context: NodeExecutionDetailRules;
  node?: ApiNode;
  isFirstEntry: boolean;
  isLastEntry: boolean;
};
const isRulesNode = (node: ApiNodeData): node is ApiNodeDataRules => {
  return node.kind === 'rules';
};
const RulesNodeGroup = t0 => {
  const $ = _c(23);
  const {
    context,
    isFirstEntry,
    isLastEntry,
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.onboardingTrace"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const rulesNodeData = node && isRulesNode(node) ? node : undefined;
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[1] !== context || $[2] !== rulesNodeData?.groups || $[3] !== rulesNodeData?.name) {
    const executedGroup = rulesNodeData?.groups.find(group => group.value === context.assignedValue);
    const triggeredConditions = executedGroup?.conditions.filter(c => context.groupResults.find(r => r.ruleId === c.id)?.result);
    T0 = RuleTraceRow;
    t2 = Boolean(triggeredConditions?.length);
    t3 = rulesNodeData?.name;
    t4 = triggeredConditions?.map(_temp) ?? [];
    $[1] = context;
    $[2] = rulesNodeData?.groups;
    $[3] = rulesNodeData?.name;
    $[4] = T0;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    T0 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
  }
  const t5 = rulesNodeData?.name;
  let t6;
  if ($[8] !== t || $[9] !== t5) {
    t6 = t(_temp2, {
      name: t5
    });
    $[8] = t;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== context || $[12] !== rulesNodeData) {
    t7 = rulesNodeData?.key && <span className="text-primary">data.{rulesNodeData.key} = {context.assignedValue}</span>;
    $[11] = context;
    $[12] = rulesNodeData;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== T0 || $[15] !== isFirstEntry || $[16] !== isLastEntry || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t6 || $[21] !== t7) {
    t8 = <T0 triggered={t2} name={t3} conditions={t4} noTriggerLabel={t6} isFirstEntry={isFirstEntry} isLastEntry={isLastEntry} outcome={t7} />;
    $[14] = T0;
    $[15] = isFirstEntry;
    $[16] = isLastEntry;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default RulesNodeGroup;
function _temp(c_0) {
  return c_0.expression;
}
function _temp2($) {
  return $.rulesExecutedNonTriggeredName;
}